
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/volantini-digitali/[categoriaSlug]",
      function () {
        return require("private-next-pages/volantini-digitali/[categoriaSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/volantini-digitali/[categoriaSlug]"])
      });
    }
  